export * from './lib/deleteFromObject';
export * from './lib/getFromObject';
export * from './lib/hasFromObject';
export * from './lib/setToObject';

export const version = '[VI]{version}[/VI]';
